import Checkbox from '@components/v2/form/Checkbox/Checkbox';
import ListItemButton from '@components/v2/ui/List/ListItemButton';
import Typography from '@components/v2/ui/Typography/Typography';
import { Stack } from '@mui/material';

interface CatalogCreationCriteriaOptionRowProps {
  label: string;
  testId: string;
  isChecked: boolean;
  description?: string;
  onClick: () => void;
}

const CatalogCreationCriteriaOptionRow = ({
  label,
  testId,
  isChecked,
  description,
  onClick,
}: CatalogCreationCriteriaOptionRowProps) => (
  <ListItemButton testId={testId} onClick={onClick}>
    <Checkbox
      aria-hidden
      size="small"
      checked={isChecked}
      sx={{ pointerEvents: 'none', mr: 1 }}
      slotProps={{ input: { tabIndex: -1, readOnly: true } }}
    />
    <Stack>
      <Typography component="span" variant="body2">
        {label}
      </Typography>
      {description && (
        <Typography component="span" variant="micro1" sx={{ color: 'text.secondary' }}>
          {description}
        </Typography>
      )}
    </Stack>
  </ListItemButton>
);

export default CatalogCreationCriteriaOptionRow;
